<div class="profile-page">
  <app-header></app-header>

  <div class="profile-container">
    <div class="profile-header">
      <h1>My Profile</h1>
    </div>

    <div class="alert-container" *ngIf="successMessage || errorMessage">
      <div class="alert success" *ngIf="successMessage">
        <div class="alert-content">
          <div class="alert-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <span>{{ successMessage }}</span>
        </div>
        <button class="alert-close" (click)="clearMessages()">×</button>
      </div>
      <div class="alert error" *ngIf="errorMessage">
        <div class="alert-content">
          <div class="alert-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <span>{{ errorMessage }}</span>
        </div>
        <button class="alert-close" (click)="clearMessages()">×</button>
      </div>
    </div>

    <div class="profile-content" *ngIf="currentUser">
      <div class="profile-section" *ngIf="!editMode && !changePasswordMode">
        <div class="profile-avatar">
          <img
            src="/assets/images/avatar-placeholder/avatar-placeholder.png"
            alt="Profile Picture"
          />
          <div class="avatar-overlay">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
              ></path>
              <path
                d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
              ></path>
            </svg>
          </div>
        </div>
        <div class="profile-info">
          <h2>{{ currentUser.first_name }} {{ currentUser.last_name }}</h2>
          <p class="profile-email">{{ currentUser.email }}</p>

          <div class="profile-actions">
            <button class="edit-profile-btn" (click)="toggleEditMode()">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                ></path>
                <path
                  d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                ></path>
              </svg>
              <span>Edit Profile</span>
            </button>
            <button
              class="change-password-btn"
              [class.disabled]="currentUser.is_oauth_user"
              (click)="toggleChangePasswordMode()"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              <span>Change Password</span>
            </button>
            <button class="top-up-btn" (click)="showTopUpModal = true">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              <span>Top Up</span>
            </button>
            <button class="tickets-btn" (click)="navigateToTickets()">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                ></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
              <span>My Tickets</span>
            </button>
            <button
              class="email-preferences-btn"
              (click)="showEmailPreferencesModal = true"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                ></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <span>Email Preferences</span>
            </button>
          </div>
        </div>
      </div>

      <div
        class="profile-section edit-form"
        *ngIf="editMode && emailChangeStep !== 'verification'"
      >
        <h2>Edit Profile</h2>

        <form [formGroup]="profileForm" (ngSubmit)="saveProfileChanges()">
          <div class="form-group">
            <label for="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              formControlName="firstName"
              class="form-control"
              [class.invalid]="
                profileForm.get('firstName')?.invalid &&
                profileForm.get('firstName')?.touched
              "
            />
            <div
              class="error-message"
              *ngIf="
                profileForm.get('firstName')?.invalid &&
                profileForm.get('firstName')?.touched
              "
            >
              First name is required
            </div>
          </div>

          <div class="form-group">
            <label for="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              formControlName="lastName"
              class="form-control"
              [class.invalid]="
                profileForm.get('lastName')?.invalid &&
                profileForm.get('lastName')?.touched
              "
            />
            <div
              class="error-message"
              *ngIf="
                profileForm.get('lastName')?.invalid &&
                profileForm.get('lastName')?.touched
              "
            >
              Last name is required
            </div>
          </div>

          <div class="form-group">
            <label for="email">Email</label>
            <input
              type="email"
              id="email"
              formControlName="email"
              class="form-control"
              [class.invalid]="
                profileForm.get('email')?.invalid &&
                profileForm.get('email')?.touched
              "
            />
            <div
              class="error-message"
              *ngIf="
                profileForm.get('email')?.invalid &&
                profileForm.get('email')?.touched
              "
            >
              <span *ngIf="profileForm.get('email')?.errors?.['required']"
                >Email is required</span
              >
              <span *ngIf="profileForm.get('email')?.errors?.['email']"
                >Please enter a valid email</span
              >
            </div>
          </div>

          <div class="form-group">
            <label for="phone_number">Phone Number (Optional)</label>
            <div class="phone-input-wrapper">
              <div class="country-code-dropdown">
                <select
                  id="country_code"
                  formControlName="country_code"
                  class="country-select"
                >
                  <option
                    *ngFor="let country of countryCodes"
                    [value]="country.dialCode"
                  >
                    {{ country.code }} {{ country.dialCode }}
                  </option>
                </select>
                <div class="dropdown-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              </div>

              <div class="phone-input">
                <input
                  type="tel"
                  id="phone_number"
                  formControlName="phone_number"
                  placeholder="Phone number"
                  class="phone-number-input"
                  [class.is-invalid]="
                    profileForm.get('phone_number')?.invalid &&
                    profileForm.get('phone_number')?.touched
                  "
                />
              </div>
            </div>
            <div
              class="error-message"
              *ngIf="
                profileForm.get('phone_number')?.invalid &&
                profileForm.get('phone_number')?.touched
              "
            >
              <div *ngIf="profileForm.get('phone_number')?.errors?.['pattern']">
                Please enter digits only (no spaces, dashes or other characters)
              </div>
              <div
                *ngIf="profileForm.get('phone_number')?.errors?.['invalidNumber']"
              >
                Invalid phone number format for {{ selectedCountry?.name }}
              </div>
            </div>
            <div class="phone-help-text">
              <small>Example: {{ getPhoneExampleNumber() }}</small>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="cancel-btn" (click)="cancelEdit()">
              Cancel
            </button>
            <button
              type="submit"
              class="save-btn"
              [disabled]="
                profileForm.invalid || isSubmitting || !profileForm.dirty
              "
            >
              <span *ngIf="!isSubmitting">Save Changes</span>
              <span *ngIf="isSubmitting" class="spinner"></span>
            </button>
          </div>
        </form>
      </div>

      <div
        class="profile-section edit-form"
        *ngIf="emailChangeStep === 'verification'"
      >
        <h2>Verify New Email</h2>

        <div class="email-verification-container">
          <div class="email-verification-header">
            <div class="notification-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <div class="verification-info">
              <h3>Email Verification Required</h3>
              <p>
                We've sent a verification code to
                <strong>{{ newEmail }}</strong>
              </p>
            </div>
          </div>

          <div class="verification-instructions">
            <p>
              Please enter the 6-digit code below to verify your new email
              address.
            </p>
            <div class="verification-steps">
              <div class="step">
                <div class="step-number">1</div>
                <div class="step-text">
                  Check your email inbox (and spam folder)
                </div>
              </div>
              <div class="step">
                <div class="step-number">2</div>
                <div class="step-text">Enter the 6-digit code below</div>
              </div>
              <div class="step">
                <div class="step-number">3</div>
                <div class="step-text">
                  Continue using your account with the new email
                </div>
              </div>
            </div>
          </div>

          <div class="verification-code-input">
            <label for="verificationCode">Verification Code</label>
            <input
              type="text"
              id="verificationCode"
              [(ngModel)]="verificationCode"
              [ngModelOptions]="{ standalone: true }"
              class="verification-input"
              maxlength="6"
              placeholder="000000"
            />
            <div class="code-expiry">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              Code will expire in 15 minutes
            </div>
          </div>

          <div class="verification-actions">
            <button type="button" class="cancel-btn" (click)="cancelEdit()">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
              Cancel
            </button>
            <button
              type="button"
              class="verify-email-btn"
              [disabled]="
                !verificationCode ||
                verificationCode.length !== 6 ||
                isSubmitting
              "
              (click)="verifyEmailChange()"
            >
              <svg
                *ngIf="!isSubmitting"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
              <span *ngIf="!isSubmitting">Verify Email</span>
              <span *ngIf="isSubmitting" class="spinner"></span>
            </button>
          </div>
        </div>
      </div>

      <div class="profile-section edit-form" *ngIf="changePasswordMode">
        <h2>Change Password</h2>

        <form [formGroup]="passwordForm" (ngSubmit)="savePasswordChanges()">
          <div class="form-group">
            <label for="currentPassword">Current Password</label>
            <div class="input-wrapper">
              <input
                [type]="showCurrentPassword ? 'text' : 'password'"
                id="currentPassword"
                formControlName="currentPassword"
                class="form-control"
                [class.invalid]="
                  passwordForm.get('currentPassword')?.invalid &&
                  passwordForm.get('currentPassword')?.touched
                "
              />
              <button
                type="button"
                class="toggle-password"
                (click)="toggleCurrentPasswordVisibility()"
                tabindex="-1"
              >
                <svg
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  *ngIf="!showCurrentPassword"
                >
                  <path
                    d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                  ></path>
                  <circle cx="12" cy="10" r="2"></circle>
                </svg>
                <svg
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  *ngIf="showCurrentPassword"
                >
                  <path
                    d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                  ></path>
                  <line
                    x1="4"
                    y1="4"
                    x2="20"
                    y2="20"
                    stroke="currentColor"
                    stroke-width="2"
                  ></line>
                </svg>
              </button>
            </div>
            <div
              class="error-message"
              *ngIf="
                passwordForm.get('currentPassword')?.invalid &&
                passwordForm.get('currentPassword')?.touched
              "
            >
              <span
                *ngIf="passwordForm.get('currentPassword')?.errors?.['required']"
                >Current password is required</span
              >
            </div>
          </div>

          <div class="form-group">
            <label for="newPassword">New Password</label>
            <div class="input-wrapper">
              <input
                [type]="showNewPassword ? 'text' : 'password'"
                id="newPassword"
                formControlName="newPassword"
                class="form-control"
                [class.invalid]="
                  passwordForm.get('newPassword')?.invalid &&
                  passwordForm.get('newPassword')?.touched
                "
              />
              <button
                type="button"
                class="toggle-password"
                (click)="toggleNewPasswordVisibility()"
                tabindex="-1"
              >
                <svg
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  *ngIf="!showNewPassword"
                >
                  <path
                    d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                  ></path>
                  <circle cx="12" cy="10" r="2"></circle>
                </svg>
                <svg
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  *ngIf="showNewPassword"
                >
                  <path
                    d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                  ></path>
                  <line
                    x1="4"
                    y1="4"
                    x2="20"
                    y2="20"
                    stroke="currentColor"
                    stroke-width="2"
                  ></line>
                </svg>
              </button>
            </div>
            <div
              class="error-message"
              *ngIf="
                passwordForm.get('newPassword')?.invalid &&
                passwordForm.get('newPassword')?.touched
              "
            >
              <span
                *ngIf="passwordForm.get('newPassword')?.errors?.['required']"
                >New password is required</span
              >
              <span
                *ngIf="passwordForm.get('newPassword')?.errors?.['pattern']"
              >
                Password must be at least 8 characters and include an uppercase
                letter, a number, and a special character
              </span>
            </div>

            <div
              class="password-strength"
              *ngIf="passwordForm.get('newPassword')?.value"
            >
              <div class="password-strength-bar">
                <div
                  class="password-strength-progress"
                  [style.width.%]="
                    getPasswordStrength(passwordForm.get('newPassword')?.value)
                  "
                  [ngClass]="{
                    weak:
                      getPasswordStrength(
                        passwordForm.get('newPassword')?.value
                      ) < 40,
                    medium:
                      getPasswordStrength(
                        passwordForm.get('newPassword')?.value
                      ) >= 40 &&
                      getPasswordStrength(
                        passwordForm.get('newPassword')?.value
                      ) < 70,
                    strong:
                      getPasswordStrength(
                        passwordForm.get('newPassword')?.value
                      ) >= 70
                  }"
                ></div>
              </div>
              <div class="password-strength-text">
                {{
                  getPasswordStrengthText(
                    passwordForm.get("newPassword")?.value
                  )
                }}
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="confirmPassword">Confirm New Password</label>
            <div class="input-wrapper">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                formControlName="confirmPassword"
                class="form-control"
                [class.invalid]="
                  (passwordForm.get('confirmPassword')?.invalid &&
                  passwordForm.get('confirmPassword')?.touched) ||
                  (passwordForm.errors?.['passwordMismatch'] &&
                  passwordForm.get('confirmPassword')?.touched)
                "
              />
              <button
                type="button"
                class="toggle-password"
                (click)="toggleConfirmPasswordVisibility()"
                tabindex="-1"
              >
                <svg
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  *ngIf="!showConfirmPassword"
                >
                  <path
                    d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                  ></path>
                  <circle cx="12" cy="10" r="2"></circle>
                </svg>
                <svg
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  *ngIf="showConfirmPassword"
                >
                  <path
                    d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                  ></path>
                  <line
                    x1="4"
                    y1="4"
                    x2="20"
                    y2="20"
                    stroke="currentColor"
                    stroke-width="2"
                  ></line>
                </svg>
              </button>
            </div>
            <div class="error-message">
              <span
                *ngIf="passwordForm.get('confirmPassword')?.errors?.['required'] && passwordForm.get('confirmPassword')?.touched"
              >
                Please confirm your new password
              </span>
              <span
                *ngIf="passwordForm.errors?.['passwordMismatch'] && passwordForm.get('confirmPassword')?.touched"
              >
                Passwords do not match
              </span>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="cancel-btn" (click)="cancelEdit()">
              Cancel
            </button>
            <button
              type="submit"
              class="save-btn"
              [disabled]="passwordForm.invalid || isSubmitting"
            >
              <span *ngIf="!isSubmitting">Update Password</span>
              <span *ngIf="isSubmitting" class="spinner"></span>
            </button>
          </div>
        </form>
      </div>

      <div class="profile-details" *ngIf="!editMode && !changePasswordMode">
        <div class="profile-card">
          <h3>Account Information</h3>
          <div class="detail-group">
            <label>Full Name:</label>
            <p>{{ currentUser.first_name }} {{ currentUser.last_name }}</p>
          </div>
          <div class="detail-group">
            <label>Email:</label>
            <p>{{ currentUser.email }}</p>
          </div>
          <div class="detail-group">
            <label>Phone number:</label>
            <p>{{ currentUser.phone_number || "No phone number added" }}</p>
          </div>
          <div class="detail-group">
            <label>Member Since:</label>
            <p>May 2025</p>
          </div>
          <div class="detail-group">
            <label>Balance:</label>
            <p class="balance">{{ formatBalance(currentUser.balance) }}</p>
          </div>
        </div>

        <div class="profile-card">
          <h3>Activity Summary</h3>
          <div class="activity-stats">
            <div class="stat-box" (click)="navigateToMyListings()">
              <span class="stat-number">{{ totalActiveListings }}</span>
              <span class="stat-label">Active Listings</span>
            </div>
            <div class="stat-box" (click)="navigateToWishlist()">
              <span class="stat-number">{{ wishlistCount }}</span>
              <span class="stat-label">Wishlist</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profile-loading" *ngIf="!currentUser">
      <div class="loading-indicator">
        <div class="loading-spinner"></div>
        <p>Loading profile information...</p>
      </div>
    </div>
  </div>

  <div
    class="modal-backdrop"
    *ngIf="showTopUpModal"
    (click)="closeTopUpModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <button class="close-modal-btn" (click)="closeTopUpModal()">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <app-top-up (topUpComplete)="onTopUpComplete($event)"></app-top-up>
    </div>
  </div>

  <div
    class="modal-backdrop"
    *ngIf="showEmailPreferencesModal"
    (click)="closeEmailPreferencesModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <button class="close-modal-btn" (click)="closeEmailPreferencesModal()">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <div class="email-preferences-content">
        <div class="email-preferences-header">
          <div class="notification-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
              ></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>
          <div class="verification-info">
            <h3>Email Preferences</h3>
            <p>Manage your email subscription settings</p>
          </div>
        </div>

        <div class="email-preferences-body">
          <div class="preference-item">
            <div class="preference-content">
              <h4>Marketing Emails</h4>
              <p>
                Receive updates about new features, promotions, and premium
                listings
              </p>
            </div>
            <label class="toggle-switch">
              <input
                type="checkbox"
                [(ngModel)]="marketingConsent"
                (change)="onMarketingConsentChange()"
                [disabled]="isUpdatingPreferences"
              />
              <span class="slider"></span>
            </label>
          </div>

          <div class="preference-note" *ngIf="marketingConsent">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <span
              >You'll receive carefully curated emails about premium listings
              and platform updates. You can unsubscribe at any time.</span
            >
          </div>

          <div class="preference-note warning" *ngIf="!marketingConsent">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
              ></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            <span
              >You won't receive marketing emails or updates about new features
              and promotions.</span
            >
          </div>
        </div>

        <div class="email-preferences-actions">
          <button
            type="button"
            class="cancel-btn"
            (click)="showEmailPreferencesModal = false"
            [disabled]="isUpdatingPreferences"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
